module.exports = __webpack_public_path__ + "static/img/pic3.8de9bbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/universityHall/images/pic3.jpg
// module id = NPDX
// module chunks = 0